export default __webpack_public_path__ + "static/ItSolutions-c7737e25a8e013cb0b0b3b04750a3b88.jpeg";